import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "menu", "input", "single", "editor"]

  connect() {
    this.dropdown = new window.Dropdown(this.menuTarget, this.triggerTarget, {
      placement: "bottom-end",
      offsetDistance: 6,
      onShow: () => {
        this.triggerTarget.setAttribute("aria-expanded", "true")
        requestAnimationFrame(() => this.inputTarget.select())
      },
      onHide: () => {
        this.triggerTarget.setAttribute("aria-expanded", "false")
        this.cancelEdit()
      },
    }, { id: this.menuTarget.id, override: true })
    this.dropdown._popperInstance.setOptions(options => ({
      ...options,
      modifiers: [...options.modifiers, { name: "preventOverflow", options: { altAxis: true, padding: 8 } }],
    }))
    this.resizeObserver = new ResizeObserver(() => this.dropdown._popperInstance.update())
    this.resizeObserver.observe(this.menuTarget)
    this.hide = this.hide.bind(this)
    document.addEventListener("turbo:before-cache", this.hide)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.hide)
    this.resizeObserver.disconnect()
    this.dropdown?.destroyAndRemoveInstance()
  }

  hide() {
    this.dropdown?.hide()
  }

  edit() {
    this.singleTarget.hidden = true
    this.editorTarget.hidden = false
  }

  cancelEdit() {
    this.singleTarget.hidden = false
    this.editorTarget.hidden = true
    this.editorTarget.removeAttribute("src")
    this.editorTarget.innerHTML = ""
    if (this.dropdown?.isVisible()) this.inputTarget.focus()
  }

  closeOnEscape(event) {
    if (event.key !== "Escape" || !this.dropdown?.isVisible()) return

    event.preventDefault()
    this.hide()
    this.triggerTarget.focus()
  }
}
